export default __webpack_public_path__ + "static/media/explore-futura-section-bg.993c9bef.png";